import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { throwError as observableThrowError, Observable, of } from "rxjs";
import { BaseRestService } from "../base-rest.service";
import { LoyaltyCardViewModel } from "../../models/dto/loyalty-card-view.model";
import { LoyaltyCardSearchRequest } from "../../models/rest/loyalty/loyalty-card-search-request.model";
import { LoyaltyCardGenerateRequest } from "../../models/rest/loyalty/loyalty-card-generate-request.model";
import { SessionStorageService } from "../session-storage.service";

@Injectable({
  providedIn: "root"
})
export class LoyaltyCardService extends BaseRestService {
  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService) {
    super(httpClient, sessionStorageService);
  }


  // Sadakat kartlar
  getLoyaltyCards(): Observable<LoyaltyCardViewModel[]> {
    const url = `/loyalty-cards`;
    return this.httpGet<LoyaltyCardViewModel[]>(url)
      .pipe(catchError(this.errorHandler));
  }
  //by Id
  getLoyaltyCardById(id): Observable<LoyaltyCardViewModel> {
    const url = `/loyalty-cards/${id}`;
    return this.httpGet<LoyaltyCardViewModel>(url)
      .pipe(catchError(this.errorHandler));
  }

  //Sadakat kartı ekle
  addLoyaltyCard(data) {
    const url = `/loyalty-cards`;
    return this.httpPost<LoyaltyCardViewModel>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  //Sadakat kartı güncelle
  updateLoyaltyCard(id, data): Observable<LoyaltyCardViewModel> {
    const url = `/loyalty-cards/${id}`;
    return this.httpPut<LoyaltyCardViewModel>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  //Sadakat kartı sil
  deleteLoyaltyCard(id) {
    const url = `/loyalty-cards/${id}`;
    return this.httpDelete(url).pipe(catchError(this.errorHandler));
  }

  // Sadakat kartlar
  getLoyaltyCardsBySearch(data: LoyaltyCardSearchRequest): Observable<LoyaltyCardViewModel[]> {
    const url = `/loyalty-cards/search`;
    return this.httpPost<LoyaltyCardViewModel[]>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  getLoyaltyCardGenerate(data: LoyaltyCardGenerateRequest) {
    const url = `/loyalty-cards/generate`;
    return this.httpPost(url, data)
      .pipe(catchError(this.errorHandler));
  }

  importExcel(data) {
    const url = `/loyalty-cards/import-excel`;
    return this.httpPost(url, data).pipe(catchError(this.errorHandler));
  }



  errorHandler(error: HttpErrorResponse) {
    // console.log("service:"+error);
    return observableThrowError(error);
  }
}
